import { ChevronLeftIcon, ChevronsRight } from "lucide-react";
import { Link } from "react-router-dom";
import { twMerge } from "tailwind-merge";
import GoBackButton, { GoBackButtonProps } from "../GoBackButton";
import Skeleton from "../Skeleton";
import Button from "../Button";

interface ShowHeaderProps {
  className?: string;
  backTo?: string;
  goBack?: boolean;
  goBackProps?: GoBackButtonProps;
  goBackIconSize?: number;
  onGoBack?: () => void;
  title?: string | JSX.Element;
  titleClassName?: string;
  subtitle?: string | JSX.Element;
  subtitleClassName?: string;
  logoClassName?: string;
  logoUrl?: string;
  LogoPlaceholder?: JSX.Element;
  badge?: JSX.Element;
  buttons?: JSX.Element | boolean | null;
  isLoading?: boolean;
}

export const ShowHeader = ({
  className,
  backTo,
  goBack,
  goBackProps,
  goBackIconSize,
  onGoBack,
  title,
  titleClassName,
  subtitle,
  subtitleClassName,
  logoClassName,
  logoUrl,
  LogoPlaceholder,
  badge,
  buttons,
  isLoading,
}: ShowHeaderProps) => {
  if (isLoading) {
    return (
      <div className="flex justify-between items-center gap-3 flex-wrap mb-6 h-10">
        <Skeleton width={250} height={24} />

        <Skeleton width={200} height={24} />
      </div>
    );
  }

  return (
    <div className={twMerge('flex justify-between items-center gap-3 flex-wrap mb-6', className)}>
      <div className="flex flex-wrap gap-2 items-center">
        {goBack && (
          <GoBackButton {...goBackProps} />
        )}

        {!goBack && backTo && (
          <Link to={backTo} className="cursor-pointer">
            <ChevronLeftIcon size={goBackIconSize || 40} strokeWidth={1} />
          </Link>
        )}

        {!goBack && !backTo && onGoBack && (
          <Button variant="link-white" onClick={onGoBack}>
            <ChevronLeftIcon size={goBackIconSize || 40} strokeWidth={1} />
          </Button>
        )}

        {logoUrl ? (
          <img
            src={logoUrl}
            alt={typeof title === 'string' ? title : ''}
            className={twMerge('size-8 rounded-full object-cover', logoClassName)}
          />
        ) : LogoPlaceholder ? (
          <>
            {LogoPlaceholder}
          </>
        ) : (
          <></>
        )}

        {title && (
          <>
            <h2 className={twMerge('text-2xl font-bold', titleClassName)}>
              {title}
            </h2>

            {subtitle && (
              <>
                <ChevronsRight className="text-white-400" />

                <h2 className={subtitleClassName}>
                  {subtitle}
                </h2>
              </>
            )}

            {badge}
          </>
        )}
      </div>

      <div className="ml-auto">
        {buttons}
      </div>
    </div>
  );
};
